var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 46,
    viewBox: "0 0 127 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.94 13.8963C39.9941 16.2091 38.7615 18.3754 37.2664 20.3403V30.7202C37.2664 31.7271 36.7233 32.6608 35.8568 33.1672L21.9071 41.2222C21.0345 41.7226 19.9544 41.7226 19.0817 41.2222L12.2472 37.2802C11.6065 36.7188 10.9535 35.8889 10.74 34.7477C10.8193 30.525 14.9932 27.2908 14.9932 27.2908L13.7179 24.9963C13.7179 24.9963 8.83606 27.2114 5.1564 25.1794C4.14953 24.2702 3.81391 23.0558 3.71627 22.1588V14.6103C3.71627 13.6034 4.25937 12.6698 5.12589 12.1633L19.0756 4.10833C19.5089 3.85814 19.9971 3.73 20.4852 3.73C20.9734 3.73 21.4616 3.85814 21.8949 4.10833L31.3778 9.58205C33.8553 9.31965 36.3633 9.39288 38.853 9.79563C38.5052 9.47221 38.1207 9.17321 37.6997 8.92912L23.75 0.874147C21.7301 -0.291382 19.2221 -0.291382 17.2022 0.874147L3.27081 8.93521C1.25706 10.1068 0 12.2732 0 14.6103V30.7141C0 33.0452 1.25706 35.2176 3.27081 36.3831L17.2205 44.4381C18.2274 45.0178 19.3624 45.3107 20.4914 45.3107C21.6203 45.3107 22.7553 45.0178 23.7622 44.4381L37.7119 36.3831C39.7317 35.2176 40.9827 33.0452 40.9827 30.7141V14.6103C40.9888 14.3662 40.9644 14.1282 40.94 13.8963Z",
    fill: "#2C6CE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4899 30.9277L28.0032 25.6188L29.7973 24.618C34.7645 21.8537 38.4259 17.2282 39.9819 11.7606C34.5143 10.2045 28.6501 10.8818 23.6889 13.6462L21.8949 14.6469L16.5859 13.1336L11.2281 16.1176L16.3357 19.0955L14.2122 22.2625L15.8476 25.1977L17.483 28.1329L21.2908 27.9926L21.1321 33.9056L26.4899 30.9277ZM26.081 16.081C27.5273 15.2755 29.3457 15.7942 30.1512 17.2404C30.9567 18.6866 30.438 20.5051 28.9918 21.3106C27.5456 22.1161 25.7271 21.5974 24.9216 20.1512C24.1161 18.7049 24.6348 16.8865 26.081 16.081Z",
    fill: "#2C6CE4"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: 28
    },
    x: 48.389,
    y: 32.854,
    transform: "matrix(1.304584, 0, 0, 1.418768, -22.325238, -9.936987)"
  }, " LPG"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2ed862b30bf02b2a31472da0eb4155a.svg";
export { ForwardRef as ReactComponent };